import React, { useEffect } from 'react';
import './Notification.css';

export type NotificationType = 'success' | 'error';

interface NotificationProps {
  message: string;
  type: NotificationType;
  onClose: () => void;
  autoClose?: boolean;
  duration?: number;
}

const Notification: React.FC<NotificationProps> = ({
  message,
  type,
  onClose,
  autoClose = true,
  duration = 3000
}) => {
  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose]);

  return (
    <div className={`notification notification-${type}`}>
      <span className="notification-message">{message}</span>
      <button onClick={onClose} className="notification-close">
        <span className="material-icons">close</span>
      </button>
    </div>
  );
};

export default Notification;
